module.exports = __webpack_public_path__ + "static/media/dagger-unique.663120a5.png";